<template>
  <b-container>
    <b-row>
      <h2>{{ $t("system.predefinedScript.predefinedScript") }}</h2>
      <success-fade-alert ref="alert" :msg="alerts.success" />
      <fade-alert-danger ref="danger" :msg="alerts.error" />
    </b-row>
    <router-link :to="'/checklist/predefinedScript/create/'">
      <b-button size="sm">Novo Script</b-button>
    </router-link>

    <b-table
      ref="predefinedScriptTable"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key">
            <div v-if="field.filterKey != 'actions'">
              <div v-if="tableFilters[field.filterKey] != null">
                <b-form-select
                  v-if="field.filterKey == 'scriptType'"
                  class="select-field"
                  :options="scriptTypeOpt"
                  :placeholder="'Buscar por ' + field.label"
                  v-model="tableFilters[field.filterKey]"
                ></b-form-select>
                <b-form-select
                  v-else-if="field.filterKey == 'active'"
                  class="select-field"
                  :options="optionsBool"
                  v-model="tableFilters[field.filterKey]"
                ></b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(actions)="data">
        <b-button
          v-if="data.item.active"
          @click="activateAndDisable(data.item.id)"
          size="sm"
          variant="danger"
          >Desativar</b-button
        >
        <b-button v-else @click="activateAndDisable(data.item.id)" size="sm"
          >Ativar</b-button
        >
        <router-link :to="'/checklist/predefinedScript/edit/' + data.item.id">
          <b-button class="ml-2" size="sm"
            ><i class="tim-icons icon-pencil"></i
          ></b-button>
        </router-link>
      </template>
    </b-table>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },

  data() {
    return {
      alerts: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      scriptTypeOpt: [
        { value: "0", text: "Calculado" },
        { value: "1", text: "Validação" },
        { value: "2", text: "Processamento" },
        { value: "3", text: "Pós processamento" },
      ],
      optionsBool: [
        { value: "", text: "Todos" },
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          label: "",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "name",
          filterKey: "name",
          label: "Nome",
          sortable: true,
        },
        {
          key: "description",
          filterKey: "description",
          label: "Descrição",
          sortable: true,
        },
        {
          key: "scriptType",
          filterKey: "scriptType",
          label: "Tipo de script",
          sortable: true,
          formatter: (value, key, item) => {
            if (item.scriptType == 0) {
              return "Calculado";
            } else if (item.scriptType == 1) {
              return "Validação";
            }
            if (item.scriptType == 2) {
              return "Processamento";
            }
            return "Pós processamento";
          },
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          formatter: (value, key, item) => {
            if (item.active) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      isBusy: false,
      tableFilters: {
        name: "",
        description: "",
        scriptType: "",
        active: "true",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      
    };
  },
  methods: {
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        name: ctx.filter.name,
        description: ctx.filter.description,
        active: ctx.filter.active,
        scriptType: ctx.filter.scriptType,
      };
      this.$apiChecklist
        .post("predefinedScript/getAll", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
    },
    activateAndDisable(itemId) {
      this.$apiChecklist
        .post("/predefinedScript/activateDisable/" + itemId)
        .then((response) => {
          this.$refs.predefinedScriptTable.refresh();
          this.$forceUpdate();
          this.$refs.alert.show();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
